import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Field from 'components/Field';
import Label from 'components/Label';
import PropTypes from 'prop-types';
import * as React from 'react';
import RelationshipActions from 'actions/RelationshipActions';
import Subscriber from 'entities/Subscriber';
import Textarea from 'components/Textarea';
import ToastActions from 'actions/ToastActions';

import type { SyntheticEvent } from 'react';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeProps'.
class RelationshipViewNotes extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    subscriber: PropTypes.instanceOf(Subscriber).isRequired,
  };

  state = {
    note: this.props.subscriber.getNote(),
  };

  handleNoteChange = (event: SyntheticEvent) => {
    // $FlowIssue
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
    this.setState({ note: event.target.value });
  };

  handleUpdateNote = () => {
    RelationshipActions.updateNote(this.props.subscriber.id, this.state.note)
      .then(() => {
        ToastActions.showSuccessToast('Notes saved');
      })
      .catch(() => {
        ToastActions.showErrorToast('An error has occurred');
      });
  };

  render() {
    const { subscriber } = this.props;
    const placeholder = `Add a note about ${subscriber.getName()} (only you can see this)`;

    return (
      <div className="RelationshipViewNotes">
        <Field>
          <Label htmlFor="">Notes</Label>
          <Textarea
            value={this.state.note}
            placeholder={placeholder}
            ref="note"
            autogrow
            rows={2}
            onChange={this.handleNoteChange}
          />
        </Field>
        <Buttons align="right" reset="none">
          <Button
            size="xsmall"
            disabled={this.state.note === subscriber.getNote()}
            onClick={this.handleUpdateNote}
          >
            Save
          </Button>
        </Buttons>
      </div>
    );
  }
}

export default RelationshipViewNotes;
